import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { logout } from './AuthSlice'
const apiURL = process.env.REACT_APP_BACKEND

const initialState = {
  lpns: [],
  lpnCount: 0,
}

export const getLpns = createAsyncThunk('lpn/getLpns', async (props, thunkAPI) => {
  // access the entire redux state
  const state = thunkAPI.getState()
  const { authId, webToken, subscriberId, customerId } = state.auth
  const filters = props && props.filters

  let reqBody = filters ? {...filters} : {}
  if (authId === 1) {
    reqBody.subscriberId = subscriberId
  } else if (authId !== 100) {
    reqBody.customerId = customerId
  }

  return await fetch(apiURL + 'api/gatelpnsNew', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': webToken
    },
    credentials: 'include',
    body: JSON.stringify(reqBody),
  })
  .then(response => response.json())
  .then(data => {
    data.pageIndex = filters && filters.page ? filters.page : 1
    return data
  })
  .catch(error => {
      console.error('Error:', error)
      // preserve the requested page so a failed load-more (page > 1) is a no-op
      // in the reducer instead of wiping the accumulated list.
      return {rows: [], pages: 0, pageIndex: filters && filters.page ? filters.page : 1}
  })
});

const lpnSlice = createSlice({
  name: 'lpn',
  initialState,
  reducers: {
    setLpnState: (state, action) => {
      state[action.payload.field] = action.payload.value
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLpns.fulfilled, (state, action) => {
        // Store holds only the latest page; infinite-scroll accumulation lives in
        // CataloguePane's own state (not persisted), so localStorage isn't bloated.
        state.lpns = action.payload.rows
        if (action.payload.count !== undefined) state.lpnCount = action.payload.count
      })
      .addCase(logout, (state, action) => {
        return { ...initialState }
      })
  },
})

export const { setLpnState } = lpnSlice.actions
export default lpnSlice.reducer
